import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FaqService } from 'src/app/services/faq.service';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dutystation-salaryscale',
  templateUrl: './dutystation_salaryscale.component.html',
  styleUrls: ['./dutystation_salaryscale.component.scss']
})
export class DutyStationSalaryScaleComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private faqService: FaqService,
    private lazyLoadService: LazyLoadScriptService,
    private activatedRoute: ActivatedRoute) { }

  template: string;
  public async ngOnInit() {
    this.template = `
    <div class="dsss section">
    <div class="container-fluid">
      <div class="heading-1">
        <h1>{{dutyStationDisplayTitle}} </h1>
      </div>
      <div class="row">
        <div class="col-md-6">
          <img src={{dutyStationImage}} class="img-fluid w-100" alt="...">
        </div>
        <div class="col-md-6">
          <div [innerHtml]='dutyStationDescription'></div>
        </div>
      </div>
      <!-- Here is the list of category documents -->
      <div *ngIf="dutyStationCatDocs?.length > 0">
        <div class="card" *ngFor="let cat of dutyStationCats;">
          <div class="card-body">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th style="width:50%" scope="col">{{cat.name}}</th>
                  <th scope="col">Promulgated</th>
                  <th scope="col">Effective</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of getCatDocs(cat._id);">
                  <td><a href={{doc.filePath}} download>{{doc.fileName}}</a></td>
                  <td>{{doc.promulgated | date:'MMMM' }} {{doc.promulgated | date:'yyyy' }}</td>
                  <td>{{doc.effective | date:'d' }} {{doc.effective | date:'MMMM' }} {{doc.effective | date:'yyyy' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
      `;
    this.compileTemplate();
  }

  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template,
      changeDetection: ChangeDetectionStrategy.Default
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
      dutyStationDisplayTitle;
      dutyStationImage;
      dutyStationDescription;
      dutyStationCats: any = {};
      dutyStationCatDocs: any = {};

      public ngOnInit() {
        THIS.service.getSalaryScaleWithDutyStationId(THIS.activatedRoute.snapshot.paramMap.get('id')).subscribe((response: any) => {
          if (response.data.result) {
            this.dutyStationDisplayTitle = response.data.result[0].displayTitle
            this.dutyStationDescription = response.data.result[0].countryDescription
            this.dutyStationImage = response.data.result[0].filePath
            this.dutyStationCats = response.data.result[0]['salaryscalecategories']
            const filteredList = response.data.result[0]['salaryscalecategorydocs']
            this.dutyStationCatDocs = filteredList.sort((a, b) => new Date(b.effective).getTime() - new Date(a.effective).getTime());
          }
        })
      }

      getCatDocs(id) {
        return this.dutyStationCatDocs.filter(docs => docs.docCategoryId === id);
      }
    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({ imports: [CommonModule, CarouselModule, BrowserModule], declarations: [decoratedCmp] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }

}

